import {getlastscan,getlastgroupinfo,getbanzuyuzhisum} from "@/api/contract.js"
import {getLastPayGroupInfo,getfafang} from "@/api/paylog.js"
import moment from "moment"
import XLSX from "xlsx"


/**
 * form操作的相关函数
 */

export const formfn = {
	getSumData(tableData){
		let {sum,rows} = tableData,pyingfu=0,pyuzhi=0,pjieyu=0,pworkday=0,pkoufafang = 0
		rows.forEach(item=>{
			let {yingfu,kouyuzhi,jieyu,koufafang} = item
			pyingfu +=parseFloat(yingfu||0)
			pyuzhi +=parseFloat( kouyuzhi||0)
			pjieyu += parseFloat(jieyu||0)
			pkoufafang += parseFloat(koufafang||0)
		})
		return {...sum,pyingfu:pyingfu.toFixed(2),pkoufafang:pkoufafang.toFixed(2),pyuzhi:pyuzhi.toFixed(2),pjieyu:pjieyu.toFixed(2),pworkday}
	},
	
	// 所在工地 发生变化
	wpchange(val,opt){
		let {data:{attrs:{text}}} = opt,
		{idcard} = this.formData
		if(text&&idcard){
			getlastscan({yiIdCard:idcard,yiWorkPlace:text}).then(ret=>{
				if(ret){
					let {ret:data} = ret
					let {yi:name,yiBank:bankname,yiBankNum:banknum,worktype,yiBanZhu:group} = data
					this.formData = {...this.formData,name,bankname,banknum,worktype,group,workplacetext:text}
				}
			})
		}
	},
	// 计算应付金额
	getyingfu(){
		let {datainfo} = this.formData
		let roomsum = 0,butiesum = 0,kouchusum = 0,pricesum = 0
		datainfo.forEach(item=>{
			let {room,price,butie,kouchu} = item
			if(room){roomsum += parseFloat(room.sum) }
			if(price){pricesum += parseFloat(price.sum) }
			if(butie){butiesum += parseFloat(butie.num) }
			if(kouchu){kouchusum += parseFloat(kouchu.num) }
		})
		
		let yingfu = pricesum + roomsum + butiesum - kouchusum 
		yingfu = yingfu&&yingfu.toFixed(2) 
		this.formData = {...this.formData,yingfu}
	},
	checkData(obj){
		return new Proxy(obj,{
			get:(tar,key)=>{
				return tar[key]?tar[key]:0
			}
		})
	},
	filehandle(file){
		const reader = new FileReader();
		reader.readAsBinaryString(file);
		reader.onload = (evt) => {
			try{
				const bstr = evt.target.result;
				const wb = XLSX.read(bstr, {type:'binary'});
				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];
				let data = XLSX.utils.sheet_to_json(ws,{
					header:"A",
				})
				data = data.slice(1)
				if(data.length != 0){
					this.formData.datainfo = data.map((item,id)=>{
						item = this.checkData(item)
						let {A,B,C,D,E,F,G,H,I,J,K,L,M} = item
						return {
							key:id,
							workplace:A,
							price:{type:B,price:C,num:D,sum:parseFloat(C*D)},
							room:{type:F,price:G,num:H,sum:parseFloat(G*H)},
							butie:{note:J,num:K},
							kouchu:{note:L,num:M},
						}
					})
				}
			}catch(e){
				console.log(e)
			}
		}
		return true
	},
	
	// 计算扣除预支金额
	getkouyuzhi(){
		let {idcard:groupidcard,workplacetext:yiWorkPlace,starttime,endtime} = this.formData
		if(typeof starttime == "object"){
			starttime = starttime.format("YYYY年MM月DD日")
		}
		if(typeof endtime == "object"){
			endtime = endtime.format("YYYY年MM月DD日")
		}
		getbanzuyuzhisum({groupidcard,yiWorkPlace,starttime,endtime}).then(ret=>{
			try{
				if(ret.code == 0){
					let {sum} = ret
					this.formData = {...this.formData,kouyuzhi:sum}
				}else{
					throw(1)
				}
			}catch(e){
				this.formData = {...this.formData,kouyuzhi:0}
			}
		})
	},
	// 计算扣除发放
	getkoufafang(){
		let {idcard,workplace,starttime,endtime} = this.formData

		if(typeof starttime == "object"){
			starttime = starttime.format("YYYY-MM-DD")
		}
		if(typeof endtime == "object"){
			endtime = endtime.format("YYYY-MM-DD")
		}
		getfafang({idcard,workplace,starttime,endtime}).then(ret=>{
			try{
				if(ret){
					this.formData = {...this.formData,koufafang:ret["ret"]}
				}
			}catch(e){
				console.log(e)
				this.formData = {...this.formData,koufafang:0}
			}
		})
	},
	//计算结余金额
	getjieyu(){
		let {shifoufafang,yingfu,koufafang,kouyuzhi} = this.formData
		if(shifoufafang){
			if(shifoufafang == 1){
				this.formData = {...this.formData,jieyu:0}
			}else{
				this.formData = {...this.formData,jieyu:(yingfu-koufafang-kouyuzhi).toFixed(2)}
			}
		}
	},
}

/**
 * 保存数据form 动态增删项操作
 * 房屋类型  补贴  扣除
 */
 export const formitemhandle = {
	 addDatainfo(){
		 this.formData.datainfo.push({
			key:(new Date()).getTime(),
			room:{type:undefined,num:"",price:"",sum:""},
			price:{type:undefined,num:"",price:"",sum:""},
			butie:{note:"",num:''},
			kouchu:{note:"",num:''},
			workplace:""
		 })
	 },
	 delDatainfo(key){
		 this.formData.datainfo = this.formData.datainfo.filter(item=>item.key!=key)
	 }
}
